module.exports = __webpack_public_path__ + "img/consulting.8c86628b.png";